import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MaterialModule } from '../../../../../shared/material/material.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CouncilProfession,
  Profession,
} from '../../../../../core/generated';
import { CouncilProfessionControllerService } from '../../../../../core/generated/api/councilProfessionController.service';
import { ProfessionControllerService } from '../../../../../core/generated/api/professionController.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-councilProfession-form',
    standalone: true,
    imports: [MaterialModule],
    templateUrl: './dialog-council-profession-form.component.html',
    styleUrl: './dialog-council-profession-form.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogCouncilProfessionFormComponent implements OnInit {
  private fb = inject(FormBuilder);
  private councilProfessionService = inject(CouncilProfessionControllerService);
  public dialogRef = inject(MatDialogRef<DialogCouncilProfessionFormComponent>);
  private professionsService = inject(ProfessionControllerService);
  private _snackBar = inject(MatSnackBar);
  private cdr = inject(ChangeDetectorRef);
  data = inject(MAT_DIALOG_DATA);
  deviceService = inject(DeviceDetectorService);

  professionForm!: FormGroup;
  professionsOptions!: Profession[];
  isMobile = this.deviceService.isMobile();
  showActivityAreas = false;

  constructor() {
    this.professionsService
      .findAll3()
      .subscribe(
        (items: Profession[]) =>
        (this.professionsOptions = items.filter(
          (item: Profession) =>
            item.active && item.councilGroup === this.data.councilGroup
        ))
      );
  }

  ngOnInit() {
    this.professionForm = this.fb.group({
      id: [null],
      professionInfo: this.fb.group({
        professionName: [null, Validators.required],
        specialty: [null, Validators.required],
        specialtyRQE: [''],
        activityAreas: this.fb.array([
          this.fb.group({
            activityArea: [''],
            activityAreaRQE: [''],
          })
        ]),
      }),
      active: [true],
      certifiedHubMedical: [false],
    });

    // // Observa mudanças na specialty
    // this.professionForm.get('professionInfo.specialty')?.valueChanges.subscribe(() => {
    //   this.showActivityAreas = false;
    //   setTimeout(() => {
    //     this.showActivityAreas = true;
    //   }, 2000);
    // });
  }

  get activityAreas() {
    return (this.professionForm.get('professionInfo.activityAreas') as any);
  }

  addActivityArea() {
    this.activityAreas.push(this.fb.group({
      activityArea: [''],
      activityAreaRQE: [''],
    }));
  }

  removeActivityArea(index: number) {
    this.activityAreas.removeAt(index);
  }

  getProfessionName() {
    if (this.professionsOptions) {
      const tiposUnicos = [
        ...new Set(this.professionsOptions.map((item) => item.professionName)),
      ];

      return tiposUnicos;
    }
    return [];
  }

  getSpecialty() {
    if (
      this.professionForm.controls['professionInfo'].get('professionName')?.value &&
      this.professionsOptions
    ) {
      let councilProfessionFiter1 = this.professionsOptions.filter(
        (councilProfession) =>
          councilProfession.professionName ===
          this.professionForm.controls['professionInfo'].get('professionName')?.value
      );
      const tiposUnicos = [
        ...new Set(councilProfessionFiter1.map((item) => item.specialty)),
      ];

      return tiposUnicos;
    }
    return [];
  }

  getActivityArea() {
    if (
      this.professionForm.controls['professionInfo'].get('specialty')?.value &&
      this.professionsOptions
    ) {
      let councilProfessionFiter1 = this.professionsOptions.filter(
        (councilProfession) =>
          councilProfession.professionName ===
          this.professionForm.controls['professionInfo'].get('professionName')?.value &&
          councilProfession.specialty ===
          this.professionForm.controls['professionInfo'].get('specialty')?.value
      );
      const tiposUnicos = [
        ...new Set(councilProfessionFiter1.map((item) => item.activityArea)),
      ];

      return tiposUnicos 
    }
    return [];
  }

  addProfession() {
    //Localizar os cadastrados
    const value = this.professionForm.value;
    // Remove áreas nulas antes de enviar
    value.professionInfo.activityAreas = value.professionInfo.activityAreas.filter((a: any) => a.activityArea);
    const councilProfessions: CouncilProfession[] = this.data.councilProfessions;
    const professionInfo = value.professionInfo;
    // Verifica duplicidade pelo nome/especialidade/área
    let duplicated = councilProfessions.some(cp =>
      cp.professionInfo?.professionName === professionInfo.professionName &&
      cp.professionInfo?.specialty === professionInfo.specialty &&
      cp.professionInfo?.activityAreas?.some((a, i) =>
        a.activityArea === professionInfo.activityAreas[i]?.activityArea
      )
    );
    if (!duplicated) {
      this.councilProfessionService.save14({
        council: { id: this.data.councilId },
        professionInfo,
        active: value.active,
        certifiedHubMedical: value.certifiedHubMedical,
      }).subscribe((councilProfessionReponse) => {
        if (councilProfessionReponse.id) {
          councilProfessions.push(councilProfessionReponse);
          this.dialogRef.close(councilProfessions);
        }
      });
    } else {
      this._snackBar.open('Você já adicionou esta área de atuação.', '', {
        duration: 5000,
      });
    }
  }

  onSpecialtyChange() {
    this.showActivityAreas = false;
    setTimeout(() => {
      // Atualiza o FormArray conforme as áreas disponíveis
      const areas = this.getActivityArea();
      const activityAreasFormArray = this.activityAreas;
      // Limpa o FormArray atual
      while (activityAreasFormArray.length > 0) {
        activityAreasFormArray.removeAt(0);
      }
      // Adiciona um FormGroup para cada área disponível
      areas.forEach(area => {
        activityAreasFormArray.push(this.fb.group({
          activityArea: [null], // Por padrão, não estará checado
          activityAreaRQE: [''],
        }));
      });
      this.showActivityAreas = true;
      this.cdr.markForCheck();
    }, 1000);
  }

  onAreaCheckboxChange(event: any, index: number, area: string) {
    const control = this.activityAreas.at(index).get('activityArea');
    if (event.checked) {
      control.setValue(area);
    } else {
      control.setValue(null);
    }
  }
}
